function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var _require = require('./supply-accounting'),
  computeSupplyBuckets = _require.computeSupplyBuckets;
function toDecimalString(value) {
  if (value === undefined || value === null || value === '') {
    return '0';
  }
  return typeof value === 'bigint' ? value.toString() : String(value);
}
function toSafeNumber(value) {
  var number = Number(value);
  return Number.isSafeInteger(number) ? number : null;
}
function getUtxoSetValue(_x, _x2, _x3) {
  return _getUtxoSetValue.apply(this, arguments);
}
function _getUtxoSetValue() {
  _getUtxoSetValue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, mod, block) {
    var _mod$database, _mod$database$getStat, _supply$calculated_to;
    var indexed, supply;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return mod === null || mod === void 0 || (_mod$database = mod.database) === null || _mod$database === void 0 || (_mod$database$getStat = _mod$database.getStatisticsByBlockHash) === null || _mod$database$getStat === void 0 ? void 0 : _mod$database$getStat.call(_mod$database, String(block.hash));
        case 1:
          indexed = _context.v;
          if (!((indexed === null || indexed === void 0 ? void 0 : indexed.calculated_total_supply) != null && indexed.calculated_total_supply !== '')) {
            _context.n = 2;
            break;
          }
          return _context.a(2, toDecimalString(indexed.calculated_total_supply));
        case 2:
          _context.n = 3;
          return computeSupplyBuckets(app, mod, block);
        case 3:
          supply = _context.v;
          return _context.a(2, toDecimalString((_supply$calculated_to = supply.calculated_total_supply) !== null && _supply$calculated_to !== void 0 ? _supply$calculated_to : supply.utxo));
      }
    }, _callee);
  }));
  return _getUtxoSetValue.apply(this, arguments);
}
function buildExplorerApiData(_x4, _x5) {
  return _buildExplorerApiData.apply(this, arguments);
}
function _buildExplorerApiData() {
  _buildExplorerApiData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, mod) {
    var _app$core, _app$core$getBlocks, _latest$instance;
    var blocks, latest, _t, _t2, _t3, _t4, _t5, _t6, _t7;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return app === null || app === void 0 || (_app$core = app.core) === null || _app$core === void 0 || (_app$core = _app$core.blockchain) === null || _app$core === void 0 || (_app$core$getBlocks = _app$core.getBlocks) === null || _app$core$getBlocks === void 0 ? void 0 : _app$core$getBlocks.call(_app$core, 1, false);
        case 1:
          blocks = _context2.v;
          latest = Array.isArray(blocks) && blocks.length ? blocks[0] : null;
          if (latest !== null && latest !== void 0 && latest.hash) {
            _context2.n = 2;
            break;
          }
          throw new Error('latest block unavailable');
        case 2:
          _context2.n = 3;
          return getUtxoSetValue(app, mod, latest);
        case 3:
          _t = _context2.v;
          _t2 = toDecimalString(latest.treasury);
          _t3 = toDecimalString(latest.graveyard);
          _t4 = toDecimalString(latest.totalFees);
          _t5 = toDecimalString(latest.previousBlockUnpaid);
          _t6 = {
            utxo_set_value: _t,
            treasury: _t2,
            graveyard: _t3,
            total_fees: _t4,
            previous_block_unpaid: _t5
          };
          _t7 = {
            latest_block_id: toSafeNumber(latest.id),
            latest_block_hash: String(latest.hash),
            latest_block_time: toSafeNumber(latest.timestamp),
            latest_block_producer: String(latest.creator || ((_latest$instance = latest.instance) === null || _latest$instance === void 0 ? void 0 : _latest$instance.creator) || '')
          };
          return _context2.a(2, {
            supply: _t6,
            blocks: _t7
          });
      }
    }, _callee2);
  }));
  return _buildExplorerApiData.apply(this, arguments);
}
module.exports = {
  buildExplorerApiData: buildExplorerApiData,
  getUtxoSetValue: getUtxoSetValue,
  toDecimalString: toDecimalString,
  toSafeNumber: toSafeNumber
};